import { Tab, TabList, Tabs } from "@chakra-ui/react";

export const CollaboratorSubTabs: React.FC<{}> = () => {
  return (
    <Tabs variant="unstyled">
      <TabList>
        <Tab
          fontSize="xs"
          fontWeight="bold"
          p="2"
          mx="px"
          borderBottom="1px"
          borderBottomColor="transparent"
          color="coolGray.400"
          _selected={{ color: "coolGray.700", borderBottomColor: "coolGray.700" }}
          _hover={{ color: "coolGray.600", borderBottomColor: "coolGray.600" }}
        >
          EXPERIENCES
        </Tab>
        <Tab
          fontSize="xs"
          fontWeight="bold"
          p="2"
          mx="px"
          borderBottom="1px"
          borderBottomColor="transparent"
          color="coolGray.400"
          _selected={{ color: "coolGray.700", borderBottomColor: "coolGray.700" }}
          _hover={{ color: "coolGray.600", borderBottomColor: "coolGray.600" }}
        >
          TRAININGS
        </Tab>
        <Tab
          fontSize="xs"
          fontWeight="bold"
          p="2"
          mx="px"
          borderBottom="1px"
          borderBottomColor="transparent"
          color="coolGray.400"
          _selected={{ color: "coolGray.700", borderBottomColor: "coolGray.700" }}
          _hover={{ color: "coolGray.600", borderBottomColor: "coolGray.600" }}
        >
          ABILITIES
        </Tab>
        <Tab
          fontSize="xs"
          fontWeight="bold"
          p="2"
          mx="px"
          borderBottom="1px"
          borderBottomColor="transparent"
          color="coolGray.400"
          _selected={{ color: "coolGray.700", borderBottomColor: "coolGray.700" }}
          _hover={{ color: "coolGray.600", borderBottomColor: "coolGray.600" }}
        >
          SCHEME APPLICATIONS
        </Tab>
        <Tab
          fontSize="xs"
          fontWeight="bold"
          p="2"
          mx="px"
          borderBottom="1px"
          borderBottomColor="transparent"
          color="coolGray.400"
          _selected={{ color: "coolGray.700", borderBottomColor: "coolGray.700" }}
          _hover={{ color: "coolGray.600", borderBottomColor: "coolGray.600" }}
        >
          CODE APPLICATIONS
        </Tab>
      </TabList>
    </Tabs>
  );
};
